import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { Feature, FeatureReqBody } from '../../../types/features';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useFeatureActions = (whichAction: 'getFeatureList' | '') => {
  // query function to fetch all the features from database declared here
  const getFeatureListHandler = useQuery({
    queryKey: ['feature-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Feature>>> => {
      const response = await getPrivateAxiosInstance('user').get(
        '/feature/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'getFeatureList'),
  });

  // mutation function to add new feature to the database declared here
  const addNewFeaturesHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: Array<FeatureReqBody>;
    }): Promise<AcademiaResponse<Feature>> => {
      const response = await getPrivateAxiosInstance('user').post(
        '/feature/create/',
        body
      );

      return response.data;
    },
  });

  // mutation function to delete feature from the database declared here
  const deleteFeatureHandler = useMutation({
    mutationFn: ({
      featureId,
    }: {
      featureId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('user').delete(`/feature/${featureId}/delete/`),
  });

  return {
    getFeatureListHandler,
    addNewFeaturesHandler,
    deleteFeatureHandler,
  };
};

export default useFeatureActions;
